<div class="modal-content modal-milvus start-service-modal">
  <div class="modal-header">
    <h6 class="modal-title" id="modal-title-default">
      {{ 'INICIAR_CONVERSA' | translate }} {{ obterCanal() }} {{ obterNumeroContato() }}
    </h6>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
      <i class="mdi mdi-close"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12" [ngClass]="{ 'col-md-6': mostrarTemplateMeta }">
        <div class="form-group">
          <label [translate]="'FILA_ATENDIMENTO'"></label>
          <ng-select
            [items]="filas"
            bindLabel="text"
            [clearable]="false"
            [searchable]="true"
            [ngModel]="filaSelecionada"
            [disabled]="filas.length === 1"
            (change)="selecionarFila($event)">
          </ng-select>
        </div>
      </div>

      <div class="col-12 col-md-6" *ngIf="mostrarTemplateMeta">
        <div class="form-group">
          <label>Template</label>
          <select-padrao
            [entidade]="'selectWppOfficialTemplate'"
            [returnObj]="true"
            [params]="integracao?.id"
            [disabled]="disabledTemplateDropDown || !integracao?.id"
            (selectChange)="changeTemplateProperties($event)"
            (retornoValores)="retornoSelectTemplatesMeta($event)">
          </select-padrao>
        </div>
      </div>
    </div>

    <div class="template-preview" *ngIf="mostrarTemplateMeta && templateContent">
      <label [translate]="'MENSAGEM'"></label>
      <div class="template-preview__body">
        <div class="template-preview__header" *ngIf="templateHeader">{{ templateHeader }}</div>
        <div class="template-preview__content">{{ templateContent }}</div>
        <div class="template-preview__footer" *ngIf="templateFooter">{{ templateFooter }}</div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-success badge-pill" (click)="confirmar()" [disabled]="!podeIniciar()">
      <span [translate]="'INICIAR_CONVERSA'"></span>
    </button>
  </div>
</div>
